const DonationWidgetAppeal = () => {
    'use strict';

    var widgets = document.querySelectorAll('.donation-widget-appeal');

    if (!widgets.length) return;

    widgets.forEach(function (form) {
        var otherInput = form.querySelector('.donation-widget-appeal__other-input');
        var otherRadio = form.querySelector('.donation-widget-appeal__amount-input--other');
        var otherWrap = form.querySelector('.donation-widget-appeal__other-option');
        var redirectUrl = form.getAttribute('data-redirect-url') || '';

        /**
         * Clear "Other" selection
         */
        function clearOtherSelection() {
            if (!otherRadio || !otherInput) return;

            otherRadio.checked = false;
            otherRadio.value = '';
            otherInput.value = '';
            otherWrap.classList.remove('is-selected');
        }

        /**
         * Select "Other" amount
         */
        function selectOtherAmount() {
            var value = otherInput.value.trim();

            form.querySelectorAll(
                '.donation-widget-appeal__amount-input:not(.donation-widget-appeal__amount-input--other)'
            ).forEach(function (input) {
                input.checked = false;
            });

            otherRadio.checked = true;
            otherRadio.value = value;
            otherWrap.classList.add('is-selected');
        }

        /**
         * Handle preset selection
         */
        form.addEventListener('change', function (event) {
            if (
                event.target.classList.contains('donation-widget-appeal__amount-input') &&
                !event.target.classList.contains('donation-widget-appeal__amount-input--other')
            ) {
                clearOtherSelection();
            }
        });

        /**
         * Other input focus
         */
        if (otherInput) {
            otherInput.addEventListener('focus', selectOtherAmount);

            otherInput.addEventListener('input', function () {
                if (this.value.trim() !== '') {
                    selectOtherAmount();
                } else {
                    otherRadio.checked = false;
                    otherRadio.value = '';
                    otherWrap.classList.remove('is-selected');
                }
            });
        }

        /**
         * Submit handler
         */
        form.addEventListener('submit', function (event) {
            event.preventDefault();

            var selectedAmount = form.querySelector('input[name="donation_amount"]:checked');
            var amount = selectedAmount ? selectedAmount.value : '';

            var appealIDField = form.querySelector('input[name="appeal_id"]');
            var appealID = appealIDField ? appealIDField.value : '';

            var appealNameField = form.querySelector('input[name="appeal_name"]');
            var appealName = appealNameField ? appealNameField.value : '';

            if (!amount || parseFloat(amount) <= 0) {
                if (otherInput) otherInput.focus();
                return;
            }

            var url = new URL(redirectUrl, window.location.origin);
            url.searchParams.set('donation_type', 'personal');
            url.searchParams.set('appeal_name', appealName);
            url.searchParams.set('other_amount', amount);
            url.searchParams.set('donation_amount', 'other');
            url.searchParams.set('appeal_id', appealID);

            window.location.href = url.toString();
        });
    });
};

export default DonationWidgetAppeal;
